import { render, staticRenderFns } from "./Ibiyinka.vue?vue&type=template&id=4a5ddbd3&scoped=true&"
import script from "./Ibiyinka.vue?vue&type=script&lang=js&"
export * from "./Ibiyinka.vue?vue&type=script&lang=js&"
import style0 from "./Ibiyinka.vue?vue&type=style&index=0&id=4a5ddbd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5ddbd3",
  null
  
)

export default component.exports